<template>
  <div>
    <h4>Seller Accounts</h4>
    <CCard>
      <AccountsList
        v-if="sellerAccounts && sellerAccounts.length > 0"
        :is-loading="isLoading"
        :accounts="sellerAccounts"
        type="seller"
      />
    </CCard>

    
    <h4 class="mt-5">
      Inactive Seller Accounts
    </h4>
  
    <InactiveAccountsList
      type="seller"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import AccountsList from './AccountsList.vue'
import InactiveAccountsList from  '@/views/Accounts/InactiveAccountsList.vue'

export default {
  name: 'SellerAccounts',

  title: 'Seller Accounts',

  components: {
    AccountsList,
    InactiveAccountsList
  },

  props: {
    type: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapState('accounts', [
      'sellerAccounts',
      'sellerAccountsSearchString',
    ]),

    filterString: {
      get() {
        return this.sellerAccountsSearchString
      },
      set(value) {
        this.SET_SELLER_ACCOUNT_SEARCH_STRING(value)
      }
    }
  },

  async created () {
    this.isLoading = true
    try {
      await this.getApprovedSellerAccounts()
    } finally {
      this.isLoading = false
    }
  },

  methods: {
    ...mapActions('accounts', [
      'searchSellerAccounts',
      'getApprovedSellerAccounts'
    ]),

    ...mapMutations('accounts', [
      'SET_SELLER_ACCOUNT_SEARCH_STRING'
    ]),   

  },
}
</script>

<style lang="scss" scoped>
</style>